module.exports = __webpack_public_path__ + "img/signature-director.b1de3a55.png";